import React from "react";
import { LOCALE_STRINGS } from "constants/locales";
import { ReactComponent as RefreshIcon } from "assets/icons/refreshIcon.svg";
import { ReactComponent as ShieldCheckIcon } from "assets/icons/shieldCheckIcon.svg";
import { ReactComponent as CalendarCheckIcon } from "assets/icons/calendarCheckIcon.svg";


export const ThreeCardFeatureSection = ({ language = "EN" }) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  const cardsData = [
    {
      icon: <RefreshIcon />,
      title:
        strings.three_card_1_title ||
        "Trade in your own currency",
      desc:
        strings.three_card_1_desc ||
        "Importers and exporters transact in their preferred local currencies, eliminating the friction and cost of forced conversions on every trade.",
    },
    {
      icon: <ShieldCheckIcon />,
      title:
        strings.three_card_2_title ||
        "Regulated without the overhead",
      desc:
        strings.three_card_2_desc ||
        "Fully regulated processing through licensed partners ensures AML and KYC compliance runs in the background, not as extra work on your side.",
    },
    {
      icon: <CalendarCheckIcon />,
      title:
        strings.three_card_3_title ||
        "Settlement you can plan around",
      desc:
        strings.three_card_3_desc ||
        "Faster settlement and lower transaction costs add up to cash flow that's predictable for every party in the chain — no more guessing when funds land.",
    },
  ];

  return (
    <section className="three-card-feature-section">
      <div className="three-card-feature-list">
        {cardsData.map((card, index) => (
          <div key={index} className="three-card-feature-item">
            <div className="three-card-feature-icon-wrapper">
              {card.icon}
            </div>

            <div className="three-card-feature-content">
              <h3 className="three-card-feature-title">{card.title}</h3>
              <p className="three-card-feature-description">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ThreeCardFeatureSection;